import Model from '@/models/Model.js';

export default class EnrollmentGroupTimePeriod extends Model {
    static entity = 'enrollment_group_time_period';

    static primaryKey = ['enrollment_group_id', 'time_period_id'];

    static fields() {
        return {
            enrollment_group_id: this.attr(null),
            time_period_id: this.attr(null),
            course_key_id: this.attr(null),
            check_in_code: this.attr(null),

            ...super.fields(),

            enrollment_group: this.belongsTo('enrollment_groups', 'enrollment_group_id'),
            time_period: this.belongsTo('time_periods', 'time_period_id'),
        };
    }
}
